import { privateClient } from '../../axiosClients/axiosClients';
import { getDownloadLink } from '../../utils';

export async function downloadEstimateFile(
  pecrId,
  siteId,
  deptId,
  eIndex,
  filename
) {
  try {
    const response = await privateClient.post(
      'DownloadFile',
      {
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId: siteId,
        departmentId: deptId,
        index: eIndex,
        filename: filename,
      },
      {
        responseType: 'blob',
      }
    );
    if (response.status === 200) {
      const blob = response.data;
      getDownloadLink(blob, filename);
    }
  } catch (error) {
    return error;
  }
}

export async function onDownloadCostImpactClick(filename, pecrId, siteId) {
  try {
    const response = await privateClient.post(
      '/DownloadFilesForCostImpact',
      {
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId: siteId,
        costImpact: 'CostImpact',
        filename,
      },
      {
        responseType: 'blob',
      }
    );
    const blob = new Blob([response.data], {
      type: response.headers['content-type'],
    });
    getDownloadLink(blob, filename);
  } catch (error) {
    console.log('error downloading cost impact file:', error);
  }
}

export async function onDownloadFileFromCreator({ pecrId, filename }) {
  try {
    const response = await privateClient.post(
      'DownloadFilesForLSC',
      {
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        filename: filename,
      },
      {
        responseType: 'blob',
      }
    );
    if (response.status === 200) {
      const blob = response.data;
      getDownloadLink(blob, filename);
    }
  } catch (error) {
    return error;
  }
}

export async function onDownloadFileForSiteOwner({ pecrId, siteId, filename }) {
  try {
    const response = await privateClient.post(
      'DownloadFileForOwner',
      {
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId: siteId,
        filename: filename,
        owner: 'Owner',
      },
      {
        responseType: 'blob',
      }
    );
    if (response.status === 200) {
      const blob = response.data;
      getDownloadLink(blob, filename);
    }
  } catch (error) {
    return error;
  }
}

export async function onDownloadFileFromSC(pecrId, siteId, filename) {
  try {
    const response = await privateClient.post(
      'DownloadFileForSiteReview',
      {
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId: siteId,
        filename: filename,
        siteReview: 'SiteReview',
      },
      {
        responseType: 'blob',
      }
    );
    if (response.status === 200) {
      const blob = response.data;
      getDownloadLink(blob, filename);
    }
  } catch (error) {
    return error;
  }
}

export async function downloadExecutingFile(
  pecrId,
  siteId,
  deptId,
  dIndex,
  filename
) {
  try {
    const response = await privateClient.post(
      'DownloadExecutingFile',
      {
        MainFolder: 'PECROverview',
        SubFolder: pecrId,
        siteId: siteId,
        departmentId: deptId,
        index: dIndex,
        pecrId: pecrId,
        filename: filename,
      },
      {
        responseType: 'blob',
      }
    );
    if (response.status === 200) {
      const blob = response.data;
      getDownloadLink(blob, filename);
    }
  } catch (error) {
    return error;
  }
}
export async function handleFileDownload(
  step = '',
  pecrId = null,
  siteId = null,
  deptId = null,
  eIndex = null,
  filename = ''
) {
  console.log('handleFileDownload called with:', {
    step,
    pecrId,
    siteId,
    deptId,
    eIndex,
    filename,
  });
  try {
    if (
      (step === 'Creator' || step === 'Coordinator review before estimates') &&
      pecrId &&
      filename !== ''
    ) {
      //To download the files on DownloadFilesForLSC API click- files uploaded by creator on overview page
      await onDownloadFileFromCreator({ pecrId, filename });
    } else if (step === 'Site Coordinator Review') {
      //To download the files on DownloadFileForSites API click- files uploaded by site coordinator on site coordinator page
      await onDownloadFileFromSC(pecrId, siteId, filename);
    } else if (step === 'Owner Review') {
      //To download the files on DownloadFileForSites API click- files uploaded by site owner on site owner page
      await onDownloadFileForSiteOwner({ pecrId, siteId, filename });
    } else if (step === 'Estimates') {
      //To download the files on DownloadFile API click
      await downloadEstimateFile(pecrId, siteId, deptId, eIndex, filename);
    } else if (step === 'Execution') {
      //To download the files on DownloadExecutingFile API click
      await downloadExecutingFile(pecrId, siteId, deptId, eIndex, filename);
    }
  } catch (error) {
    return error;
  }
}
